export default "__VITE_ASSET__LmhJgaak__"